'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    display: grid;\n    grid-template-columns: ', ';\n    grid-auto-rows: 200px;\n    grid-gap: 35px;\n    padding-top: 50px;\n'], ['\n    display: grid;\n    grid-template-columns: ', ';\n    grid-auto-rows: 200px;\n    grid-gap: 35px;\n    padding-top: 50px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: grid;\n'], ['\n    display: grid;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: grid;\n    transform: rotateY(180deg);\n'], ['\n    display: grid;\n    transform: rotateY(180deg);\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    display: grid;\n    position: relative;\n    align-items: center;\n    border-style: solid;\n    border-color: ', ';\n    border-radius: 5px;\n    cursor: pointer;\n    transition: transform 0.8s;\n    ', '\n    ', '\n\n    ', '\n'], ['\n    display: grid;\n    position: relative;\n    align-items: center;\n    border-style: solid;\n    border-color: ', ';\n    border-radius: 5px;\n    cursor: pointer;\n    transition: transform 0.8s;\n    ', '\n    ', '\n\n    ', '\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    right: 10px;\n    display: flex;\n    justify-content: space-between;\n    ', '\n'], ['\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    right: 10px;\n    display: flex;\n    justify-content: space-between;\n    ', '\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    display: grid;\n    justify-items: center;\n'], ['\n    display: grid;\n    justify-items: center;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactSvg = require('react-svg');

var _getScreenSize = require('../../helpers/getScreenSize');

var _getScreenSize2 = _interopRequireDefault(_getScreenSize);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _header = require('../../atoms/text/header');

var _header2 = _interopRequireDefault(_header);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _colors = require('../../constants/colors');

var _sizes = require('../../constants/sizes');

var _isMobile = require('../../helpers/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

var _getColor = require('../../helpers/getColor');

var _getColor2 = _interopRequireDefault(_getColor);

var _info = require('../../atoms/icons/card/info');

var _info2 = _interopRequireDefault(_info);

var _check = require('../../atoms/icons/card/check');

var _check2 = _interopRequireDefault(_check);

var _close = require('../../atoms/icons/card/close');

var _close2 = _interopRequireDefault(_close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ButtonContainer = _styledComponents2.default.div(_templateObject, function (_ref) {
    var mobile = _ref.mobile;
    return mobile ? '250px' : '200px 200px 200px';
});

var FrontContainer = _styledComponents2.default.div(_templateObject2);
var BackContainer = _styledComponents2.default.div(_templateObject3);

var OptionContainer = _styledComponents2.default.div(_templateObject4, _colors.Colors.StrokeLight, function (_ref2) {
    var flipped = _ref2.flipped;
    return flipped && 'transform: rotateY(180deg); align-items: start;';
}, function (_ref3) {
    var color = _ref3.color;
    return color && 'background-color: ' + (0, _getColor2.default)(color) + ';';
}, function (_ref4) {
    var mode = _ref4.mode;
    return mode === 'buttons' && '&:hover {\n      transition: all 0.8s;\n      background-color: ' + _colors.Colors.Secondary + ';\n    }';
});

var TopContainer = _styledComponents2.default.div(_templateObject5, function (_ref5) {
    var color = _ref5.color;
    return color && 'background-color: ' + (0, _getColor2.default)(color) + ';';
});

var BottomContainer = _styledComponents2.default.div(_templateObject6);

var CardRadio = function (_React$Component) {
    _inherits(CardRadio, _React$Component);

    function CardRadio(props) {
        _classCallCheck(this, CardRadio);

        var _this = _possibleConstructorReturn(this, (CardRadio.__proto__ || Object.getPrototypeOf(CardRadio)).call(this, props));

        _this.state = {
            selected: _this.props.default || '',
            descOfOption: ''
        };
        return _this;
    }

    _createClass(CardRadio, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                context = _props.context,
                options = _props.options,
                mode = _props.mode,
                clickEvent = _props.clickEvent;

            var mobile = (0, _isMobile2.default)((0, _getScreenSize2.default)());

            var handleIClick = function handleIClick(e, code) {
                e.stopPropagation();
                _this2.setState({ descOfOption: code });
            };

            var handleXClick = function handleXClick(e) {
                e.stopPropagation();
                _this2.setState({ descOfOption: '' });
            };

            var handleOptionClick = function handleOptionClick(isActive, code) {
                isActive && _this2.setState({ selected: code });
                clickEvent(code);
            };

            return _react2.default.createElement(
                ButtonContainer,
                { mobile: mobile },
                options.map(function (option) {
                    var isActive = option.active;
                    var isSelected = option.code === _this2.state.selected;
                    var showDescription = _this2.state.descOfOption === option.code;
                    var imageURL = context && context.configuration && context.configuration.content && context.configuration.content + '/images/input/cardIcons/' + option.image + '.svg';

                    return _react2.default.createElement(
                        OptionContainer,
                        {
                            flipped: showDescription,
                            mode: mode,
                            color: (isSelected || showDescription) && isActive ? _colors.Colors.Secondary : !isActive ? _colors.Colors.StrokeLight : _colors.Colors.LightMode,
                            onClick: function onClick() {
                                return handleOptionClick(isActive, option.code);
                            },
                            key: option.code
                        },
                        showDescription ? _react2.default.createElement(
                            BackContainer,
                            null,
                            _react2.default.createElement(
                                TopContainer,
                                { onClick: handleXClick },
                                _react2.default.createElement(_close2.default, { disable: !option.active })
                            ),
                            _react2.default.createElement(
                                BottomContainer,
                                null,
                                option.description && _react2.default.createElement(_label2.default, {
                                    text: option.description,
                                    top: _sizes.Sizes.lg,
                                    left: _sizes.Sizes.sm,
                                    right: _sizes.Sizes.sm,
                                    color: isActive ? _colors.Colors.LightMode : _colors.Colors.StrokeVeryDark,
                                    size: _sizes.Sizes.sm
                                })
                            )
                        ) : _react2.default.createElement(
                            FrontContainer,
                            null,
                            _react2.default.createElement(
                                TopContainer,
                                null,
                                _react2.default.createElement(
                                    _container2.default,
                                    { clickEvent: function clickEvent(e) {
                                            return handleIClick(e, option.code);
                                        } },
                                    option.description && _react2.default.createElement(_info2.default, { light: isSelected && isActive })
                                ),
                                isSelected && isActive && mode !== 'buttons' && _react2.default.createElement(_check2.default, null)
                            ),
                            _react2.default.createElement(
                                BottomContainer,
                                null,
                                option.image && _react2.default.createElement(_reactSvg.ReactSVG, {
                                    beforeInjection: function beforeInjection(svg) {
                                        svg.setAttribute('style', 'width: 50px; height: 50px');
                                    },
                                    src: imageURL }),
                                option.name && _react2.default.createElement(_header2.default, {
                                    size: _sizes.Sizes.sm,
                                    left: _sizes.Sizes.sm,
                                    right: _sizes.Sizes.sm,
                                    text: option.name,
                                    color: isSelected && isActive ? _colors.Colors.LightMode : _colors.Colors.StrokeVeryDark })
                            )
                        )
                    );
                })
            );
        }
    }]);

    return CardRadio;
}(_react2.default.Component);

exports.default = CardRadio;